/**
 * Defines background designs.
 * @public
 */
declare enum BackgroundDesign {
  /**
   * A solid background color dependent on the theme.
   * @public
   */
  Solid = "Solid",
  /**
   * Transparent background.
   * @public
   */
  Transparent = "Transparent",
  /**
   * A translucent background depending on the opacity value of the theme.
   * @public
   */
  Translucent = "Translucent"
}
export {BackgroundDesign};
